
import PublicPropertyCard from "./PublicPropertyCard";

interface Property {
  id: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  price: number;
  bedrooms: number;
  bathrooms: number;
  square_feet: number;
  image_url?: string;
  created_at: string;
}

interface PublicPropertyGridProps {
  properties: Property[];
}

const PublicPropertyGrid = ({ properties }: PublicPropertyGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
      {properties.map((property) => (
        <PublicPropertyCard key={property.id} property={property} />
      ))}
    </div>
  );
};

export default PublicPropertyGrid;
